import React, { useState , useEffect} from "react";
import { useParams } from "react-router-dom";
import "../Assets/css/influencer.css";
import user from "../Assets/Img/message1.png";
import Saveicon from "../Assets/Img/Saveicon.png";
import collaborateicon from "../Assets/Img/collaborateicon.png";
import ArrowInfluDetail from "../Assets/Img/ArrowInfluDetail.png";
import { Link } from "react-router-dom";
import CollaborationModal from "./CollaborationModal";
import axiosMain from "../http/axiosMain";


function InfluencerDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const { id } = useParams();
  const [InfluencerDetailData, setInfluencerDetailData] = useState(null);
  const fetchCampaign = async () => {
    try {
      const response = await axiosMain.get("/api/v1/all", {
        params: {
          campaign_id: id,
        },
      });
      setInfluencerDetailData(response.data.campaigns[0]);
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };
  useEffect(() => {
    fetchCampaign();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getUTCFullYear();

    const daySuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month} ${year}`;
  };

  const handleSaveCampaign = async () => {
    try {
      if (!InfluencerDetailData) {
        console.error("Campaign data not available.");
        return;
      }
      const response = await axiosMain.post("/api/v1/save-campaign", {
        campaignId: InfluencerDetailData.campaign_id, // Directly use campaign_id
        action: "save",
      });
      if (response.status == 200) {
      }
    } catch (error) {
      console.error(
        "Error saving campaign:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div className="container-detail">
      <div className="card-detail">
        <div className="header">
          <div className="brand">
            <img src={user} alt="Puma logo" className="logo" />
            <span className="brand-name">Puma</span>
          </div>
          <Link to="#" className="view-profile">
            View Brand's Profile{" "}
            <img
              src={ArrowInfluDetail}
              alt="Arrow Icon"
              className="inline-block w-4 h-4 ml-1"
            />
          </Link>
        </div>

        <section className="overview">
          <h2 className="section-title">Overview</h2>
          <div className="name mb-3 mt-2">
            <h3 className="campaign-name">
              {InfluencerDetailData?.campaign_title}
            </h3>
          </div>
          <p className="campaign-subtitle">
            {InfluencerDetailData?.campaign_obj}
          </p>
          <p className="campaign-description">
            {InfluencerDetailData?.description}
          </p>
        </section>

        <section className="compensation">
          <h2 className="section-title">Compensation</h2>
          <div className="compensation-details">
            <span className="compensation-type">Flat fee and Product</span>
            <span className="compensation-amount">
              {InfluencerDetailData?.budget}
            </span>
          </div>
        </section>

        <section className="target-audience">
          <h2 className="section-title">Target Audience</h2>
          <div className="info-row">
            <span className="info-label">Location</span>
            <span className="info-value">
              {InfluencerDetailData?.city},{InfluencerDetailData?.state}
            </span>
          </div>
          <div className="info-row">
            <span className="info-label">Gender</span>
            <span className="info-value">{InfluencerDetailData?.gender}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Language</span>
            <span className="info-value">{InfluencerDetailData?.language}</span>
          </div>
        </section>

        <section className="deliverables">
          <h2 className="section-title mt-3">Expected Deliverables</h2>
          <div className="info-row">
            <span className="info-label">Schedule</span>
            <span className="info-value">
              {formatDate(InfluencerDetailData?.start_date)} to{" "}
              {formatDate(InfluencerDetailData?.end_date)}
            </span>
            ;
          </div>
          <div className="info-row">
            <span className="info-label">Weekly Timeline</span>
            <span className="info-value">
              {InfluencerDetailData?.timeline &&
                Array.isArray(JSON.parse(InfluencerDetailData?.timeline)) &&
                JSON.parse(InfluencerDetailData?.timeline).map((weekData) => {
                  // Extracting values
                  const { Instagram, YouTube } = weekData;

                  // Collecting Instagram activities
                  const instagramActivities = [];
                  if (Instagram?.reels > 0)
                    instagramActivities.push(`${Instagram.reels} Reels`);
                  if (Instagram?.posts > 0)
                    instagramActivities.push(`${Instagram.posts} Posts`);
                  if (Instagram?.story > 0)
                    instagramActivities.push(`${Instagram.story} Stories`);

                  // Collecting YouTube activities
                  const youtubeActivities = [];
                  if (YouTube?.shorts > 0)
                    youtubeActivities.push(`${YouTube.shorts} Shorts`);
                  if (YouTube?.videos > 0)
                    youtubeActivities.push(`${YouTube.videos} Videos`);
                  if (YouTube?.live_stream > 0)
                    youtubeActivities.push(
                      `${YouTube.live_stream} Live Streams`
                    );

                  return (
                    <div key={weekData.week}>
                      <h5 className="mt-3">Week {weekData.week}</h5>
                      {instagramActivities.length > 0 && (
                        <p>
                          <b>Instagram</b>: {instagramActivities.join(", ")}
                        </p>
                      )}
                      {youtubeActivities.length > 0 && (
                        <p>
                          <b>YouTube</b>: {youtubeActivities.join(", ")}
                        </p>
                      )}
                    </div>
                  );
                })}
            </span>
          </div>
        </section>

        <div className="actions">
          <button className="btn btn-save" onClick={() => handleSaveCampaign()}>
            <img src={Saveicon} alt="Save Campaign" className="icon me-2" />
            Save Campaign
          </button>

          <button
            className="btn btn-secondary"
            onClick={() => setIsModalOpen(true)}
            
          >
            <img src={collaborateicon} alt="Save Campaign" className="icon" />{" "}
            Collaborate
          </button>
        </div>
      </div>
      <CollaborationModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        InfluencerDetailData={InfluencerDetailData}
      />
    </div>
  );
}

export default InfluencerDetail;
